import { render } from "./Details.vue?vue&type=template&id=39fe8a6c&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=39fe8a6c&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fe8a6c"]])

export default __exports__